import React from 'react';
import { Link } from 'react-router-dom';
import { useCurrentTracklog, useDebriefRouter } from 'ff/debrief/hooks';
import styled from 'styled-components';

interface Props {
    tracklogId?: string;
    onClick?: () => void;
}

const LinkToTracklog = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren<Props>
>(function LinkToTracklog(props, ref) {
    const { tracklogId, ...rest } = props;
    const { tracklog } = useCurrentTracklog();
    const { getTracklogRouteString } = useDebriefRouter();
    const pathString = getTracklogRouteString(
        tracklogId || tracklog?.trackUuid
    );
    if (pathString)
        return (
            <UnstyledLink ref={ref} to={pathString} {...rest}>
                {props.children}
            </UnstyledLink>
        );
    else return null;
});

const UnstyledLink = styled(Link)`
    text-decoration: inherit;
    color: inherit;
`;

export default LinkToTracklog;
